import Validator from './validator.js';

export default class RegexValidator extends Validator {
    valid() {
        const { regex } = this.input.el.dataset;
        const ignoreCase = this.input.el.dataset.regexIgnoreCase !== undefined ? 'i' : '';
        const { value } = this.input.el;
        return Promise.resolve(!value || RegExp(regex, ignoreCase).test(value));
    }

    static applies(input) {
        return input.el.dataset.regex !== undefined;
    }
}
